import { gql, TypedDocumentNode } from "@apollo/client";

export type FinalizeMemberElectionsMutationResponse = {
  finalizeMemberElections: {
    success: boolean;
    message: string;
    successfulApplicationIds: string[];
    failedApplicationIds: string[];
  };
};

export type FinalizeMemberElectionsMutationVariables = {
  applicationIds: string[];
};

export const FINALIZE_MEMBER_ELECTIONS_MUTATION: TypedDocumentNode<
  FinalizeMemberElectionsMutationResponse,
  FinalizeMemberElectionsMutationVariables
> = gql`
  mutation FinalizeMemberElections($applicationIds: [ID!]!) {
    finalizeMemberElections(applicationIds: $applicationIds) {
      success
      message
      successfulApplicationIds
      failedApplicationIds
    }
  }
`;

export type UpdateMembershipApplicationElectionDatesResponse = {
  updateMembershipApplicationElectionDates: {
    success: boolean;
    message: string;
    updatedCount: number;
  };
};

export type UpdateMembershipApplicationElectionDatesVariables = {
  input: {
    applicationIds: string[];
    electionDateId?: string | null;
  };
};

export const UPDATE_MEMBERSHIP_APPLICATION_ELECTION_DATES_MUTATION: TypedDocumentNode<
  UpdateMembershipApplicationElectionDatesResponse,
  UpdateMembershipApplicationElectionDatesVariables
> = gql`
  mutation UpdateMembershipApplicationElectionDates($input: UpdateMembershipApplicationElectionDatesInput!) {
    updateMembershipApplicationElectionDates(input: $input) {
      success
      message
      updatedCount
    }
  }
`;

export type GenerateElectionMagazineListMutationData = {
  generateElectionMagazineList: {
    success: boolean;
    message: string;
    url: string;
  };
};

export type GenerateElectionMagazineListMutationVariables = {
  input: {
    electionRunId?: string;
    electionRunIds?: string[];
  };
};

export const GENERATE_ELECTION_MAGAZINE_LIST_MUTATION: TypedDocumentNode<
  GenerateElectionMagazineListMutationData,
  GenerateElectionMagazineListMutationVariables
> = gql`
  mutation GenerateElectionMagazineList($input: BackofficeGenerateElectionMagazineListInput!) {
    generateElectionMagazineList(input: $input) {
      success
      message
      url
    }
  }
`;

export type GenerateElectionPastPresidentsRosterMutationData = {
  generateElectionPastPresidentsRoster: {
    success: boolean;
    message: string;
    url: string;
  };
};

export type GenerateElectionPastPresidentsRosterMutationVariables = {
  input: {
    electionRunId?: string;
    electionRunIds?: string[];
    pastPresidentAssigneeIds?: string[];
  };
};

export type ElectionPastPresidentAssigneeMutationResult = {
  success: boolean;
  message: string;
  assignee?: { id: string; name: string } | null;
  assignees?: { id: string; name: string }[] | null;
};

export type AddElectionPastPresidentAssigneeMutationVariables = {
  input: { name: string };
};

export type RemoveElectionPastPresidentAssigneeMutationVariables = {
  input: { id: string };
};

export const ADD_ELECTION_PAST_PRESIDENT_ASSIGNEE_MUTATION: TypedDocumentNode<
  { addElectionPastPresidentAssignee: ElectionPastPresidentAssigneeMutationResult },
  AddElectionPastPresidentAssigneeMutationVariables
> = gql`
  mutation AddElectionPastPresidentAssignee($input: BackofficeAddElectionPastPresidentAssigneeInput!) {
    addElectionPastPresidentAssignee(input: $input) {
      success
      message
      assignee {
        id
        name
      }
    }
  }
`;

export const REMOVE_ELECTION_PAST_PRESIDENT_ASSIGNEE_MUTATION: TypedDocumentNode<
  { removeElectionPastPresidentAssignee: ElectionPastPresidentAssigneeMutationResult },
  RemoveElectionPastPresidentAssigneeMutationVariables
> = gql`
  mutation RemoveElectionPastPresidentAssignee($input: BackofficeRemoveElectionPastPresidentAssigneeInput!) {
    removeElectionPastPresidentAssignee(input: $input) {
      success
      message
      assignees {
        id
        name
      }
    }
  }
`;

export const GENERATE_ELECTION_PAST_PRESIDENTS_ROSTER_MUTATION: TypedDocumentNode<
  GenerateElectionPastPresidentsRosterMutationData,
  GenerateElectionPastPresidentsRosterMutationVariables
> = gql`
  mutation GenerateElectionPastPresidentsRoster($input: BackofficeGenerateElectionPastPresidentsRosterInput!) {
    generateElectionPastPresidentsRoster(input: $input) {
      success
      message
      url
    }
  }
`;
